/**
 * @class 表模型
 */

// const Op = require("./Op.js");
// const Model = require("./model");
import Op from "./Op";
import Model from "./model";

class Sequelize {
  constructor() {
    this.options = {
      define: {}
    };
  }

  /**
   * define a new model, reflect to an entity
   * @param {string} modelName 模型名
   * @param {object} attributes 属性对象
   * @param {object} options 其他选项
   */
  define(modelName, attributes, options = {}) {
    options.modelName = modelName;
    // 将Sequelize和Model关联
    options.sequelize = this;

    // const model = class extends Model {};
    const model = new Model();

    model.init(attributes, options);

    return model;
  }
}

// 操作符
Sequelize.Op = Op;

export default Sequelize;
